// TODO: better import syntax?
import {BaseAPIRequestFactory, RequiredError, COLLECTION_FORMATS} from './baseapi';
import {Configuration} from '../configuration';
import {RequestContext, HttpMethod, ResponseContext, HttpFile, HttpInfo} from '../http/http';
import {ObjectSerializer} from '../models/ObjectSerializer';
import {ApiException} from './exception';
import {canConsumeForm, isCodeInRange} from '../util';
import {SecurityAuthentication} from '../auth/auth';


import { SlipsSignedUrlRetrieve200Response } from '../models/SlipsSignedUrlRetrieve200Response';

/**
 * no description
 */
export class SlipsApiRequestFactory extends BaseAPIRequestFactory {

    /**
     * @param slipId 
     */
    public async slipsSignedUrlRetrieve(slipId: number, _options?: Configuration): Promise<RequestContext> {
        let _config = _options || this.configuration;

        // verify required parameter 'slipId' is not null or undefined
        if (slipId === null || slipId === undefined) {
            throw new RequiredError("SlipsApi", "slipsSignedUrlRetrieve", "slipId");
        }


        // Path Params
        const localVarPath = '/api/v1/slips/{slip_id}/signed-url/'
            .replace('{' + 'slip_id' + '}', encodeURIComponent(String(slipId)));

        // Make Request Context
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


        let authMethod: SecurityAuthentication | undefined;
        // Apply auth methods
        authMethod = _config.authMethods["cookieAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        // Apply auth methods
        authMethod = _config.authMethods["tokenAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        
        const defaultAuth: SecurityAuthentication | undefined = _options?.authMethods?.default || this.configuration?.authMethods?.default
        if (defaultAuth?.applySecurityAuthentication) {
            await defaultAuth?.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

}

export class SlipsApiResponseProcessor {

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to slipsSignedUrlRetrieve
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async slipsSignedUrlRetrieveWithHttpInfo(response: ResponseContext): Promise<HttpInfo<SlipsSignedUrlRetrieve200Response >> {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: SlipsSignedUrlRetrieve200Response = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "SlipsSignedUrlRetrieve200Response", ""
            ) as SlipsSignedUrlRetrieve200Response;
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: SlipsSignedUrlRetrieve200Response = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "SlipsSignedUrlRetrieve200Response", ""
            ) as SlipsSignedUrlRetrieve200Response;
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }

        throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers);
    }

}
